/* eslint-disable max-len */
import React from 'react';
function WarningOutline() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.5L1 21.5H23L12 2.5ZM12 6.49L19.53 19.5H4.46997L12 6.49ZM13 10.5H11V14.5H13V10.5ZM13 18.5V16.5H11V18.5H13Z" })));
}
export default WarningOutline;
